export default __webpack_public_path__ + "static/img-app-graphs--mobile-9a5cc22d500fb3a88329256e681287f6.webp";